import React from 'react'
import { View } from 'components/View'
import { defineMessages } from 'react-intl'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import TextTitleCondensed from 'components/TextTitleCondensed'
import useIntl from 'modules/component/utils/hooks/useIntl'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import { FaqItem } from 'pages/Creators/Faqs/Faq/index.js'

const messages = defineMessages({
  faq: {
    id: 'CreatorFAQ.faq',
    defaultMessage: 'FAQ'
  },
  q1: {
    id: 'CreatorFAQ.q1',
    defaultMessage: 'How much does it cost?'
  },
  a1: {
    id: 'CreatorFAQ.a1',
    defaultMessage: 'It’s 100% free to sign up. Then you will get 85% anytime a customer purchases one of your plans and we will get 15%. There are no hidden fees or management'
  },
  q2: {
    id: 'CreatorFAQ.q2',
    defaultMessage: 'When will I get paid?'
  },
  a2: {
    id: 'CreatorFAQ.a2',
    defaultMessage: 'Our goal is to pay you as fast as possible. Payouts are sent weekly on Monday and they cover the purchases completed 2 weeks prior. So if a customer made a purchase on the week of Monday 1st, you will get paid on Monday 14th.'
  },
  q3: {
    id: 'CreatorFAQ.q3',
    defaultMessage: 'Do I have access to my customers data?'
  },
  a3: {
    id: 'CreatorFAQ.a3',
    defaultMessage: 'Yes, you have access to your customers’ name, email and the plans they’ve purchased from you.'
  },
  q4: {
    id: 'CreatorFAQ.q4',
    defaultMessage: 'Can my customers purchase plans from other creators?'
  },
  a4: {
    id: 'CreatorFAQ.a4',
    defaultMessage: 'When they purchase your plan, this revenue belongs to you. However, customers can also decide to try a different style of training with another creator from our platform.'
  },
  q5: {
    id: 'CreatorFAQ.q5',
    defaultMessage: 'Will you communicate with my customers?'
  },
  a5: {
    id: 'CreatorFAQ.a5',
    defaultMessage: 'We will only send customers transactional emails (forgot password, verify email, etc.) and updates regarding the platform, but no promotional emails about other creators.'
  },
  q6: {
    id: 'CreatorFAQ.q6',
    defaultMessage: 'What type of content can I upload?'
  },
  a6: {
    id: 'CreatorFAQ.a6',
    defaultMessage: 'The Gymaholic platform supports short and long format videos. We want to provide you the tools so you can create the best content possible, connect with customers and grow your brand.'
  }
})

const faq = [
  {
    question: messages.q1,
    answer: messages.a1
  },
  {
    question: messages.q2,
    answer: messages.a2
  },
  {
    question: messages.q3,
    answer: messages.a3
  },
  {
    question: messages.q4,
    answer: messages.a4
  },
  {
    question: messages.q5,
    answer: messages.a5
  },
  {
    question: messages.q6,
    answer: messages.a6
  }
]

export default function CreatorFAQ (props) {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const intl = useIntl()

  return (
    <View
      bgc='#151D21'
      py='100px'
      px={isSmallScreen ? '32px' : 0}
      mt={isSmallScreen ? '-10px' : 0}
      {...props}
    >
      <View
        w={isSmallScreen ? 'unset' : '960px'}
        m={isSmallScreen ? 'unset' : '0 auto'}
      >
        <TextTitleCondensed
          c='#FFFFFF'
          fs={isSmallScreen ? '42px' : '58px'}
          fw='870'
          mb={isSmallScreen ? '20px' : '40px'}
        >{formatMessageIntlUtil(intl, messages.faq)}
        </TextTitleCondensed>
        <View>
          {faq.map((faq, index) => (
            <FaqItem
              faq={faq}
              key={index}
            />
          ))}
        </View>
      </View>
    </View>
  )
}
